// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"6c04624e","716":"8c165ca0"}[chunkId] + ".chunk.js";
};